import React from 'react';

function FranceIcon() {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            transform="translate(0, 3)"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0_13_2)">
                <path
                d="M0.712494 12C0.712494 16.9125 3.86249 21.075 8.21249 22.6125V1.3875C3.86249 2.925 0.712494 7.0875 0.712494 12Z"
                fill="#428BC1"
                />
                <path
                d="M23.2125 12C23.2125 7.0875 20.1 2.925 15.7125 1.3875V22.6125C20.1 21.075 23.2125 16.9125 23.2125 12Z"
                fill="#ED4C5C"
                />
                <path
                d="M8.21249 22.6125C9.37499 23.025 10.65 23.25 11.9625 23.25C13.275 23.25 14.55 23.025 15.7125 22.6125V1.3875C14.55 0.975 13.3125 0.75 11.9625 0.75C10.6125 0.75 9.37499 0.975 8.21249 1.3875V22.6125Z"
                fill="white"
                />
            </g>
            <defs>
                <clipPath id="clip0_13_2">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
}

export default FranceIcon;
